<template>
    <Dialog :value="value" @input="$listeners.input" :title="'Atenção'" width="600">
        <p>
            {{ text }} <br v-if="!auth">
            <span v-if="!auth">O motivo digitado será exibido ao usuário vendedor parceiro!</span>
        </p>

        <m-form ref="form" class="pt-4" @submit.prevent="vincular">
            <m-text-field ref="input"
                          label="Motivo:"
                          :hint="!auth ? 'O motivo digitado será exibido ao usuário vendedor parceiro!' : null "
                          class="required"
                          type="text"
                          v-model="motivo"
                          :rules="[$rules.minCharactersRequired]"
                          placeholder="Descreva o motivo da troca do status de autorização"
                          maxlength="800"
                          outlined>
            </m-text-field>
        </m-form>
        <v-layout class="justify-end">
            <v-btn color="secondary" class="mt-5 mr-4" @click="fechar()">Fechar</v-btn>
            <v-btn id="ButtonFinalizar" class="mt-5" color="primary" @click="authorizeSale()">
                Confirmar
            </v-btn>
        </v-layout>
    </Dialog>
</template>

<script>
  import { CreditasAvaliationStatus } from '../../../../plugins/constants'

  export default {
    name: 'DialogConfirmChangeAutorization',
    props: {
      value: Boolean,
      text: String,
      statusAvaliacaoCredita: String,
      consulta: Object,
      auth: Number
    },
    data: () => ({
      motivo: '',
      pass_visible: false
    }),
    computed: {
      CreditasAvaliationStatus: () => CreditasAvaliationStatus
    },
    watch: {
      value (open) {

      }
    },
    methods: {
      fechar () {
        this.motivo = ''
        this.$refs.form.resetValidation()
        this.$emit('input', false)
      },
      async authorizeSale () {
        const form = this.$refs.form
        if (form.validate()) {
          this.$emit('decideSale', this.consulta, this.auth, this.motivo)
          this.fechar()
        }
      },
      reload () {
        this.motivo = ''
        this.$refs.form.resetValidation()
        this.$emit('reload')
        this.$emit('input', false)
        return true
      }
    }
  }
</script>

<style scoped>

</style>
